import { render } from "./App.vue?vue&type=template&id=4398d05c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4398d05c&lang=css"
script.render = render

export default script